import { render, staticRenderFns } from "./rec_fee_schdl.vue?vue&type=template&id=70bf0e1d&scoped=true&"
import script from "./rec_fee_schdl.vue?vue&type=script&lang=js&"
export * from "./rec_fee_schdl.vue?vue&type=script&lang=js&"
import style0 from "./rec_fee_schdl.vue?vue&type=style&index=0&id=70bf0e1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf0e1d",
  null
  
)

export default component.exports